// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BACK_TO_LIST_OF_GROUPS = "Sp\u00e4\u0165 na zoznam skup\u00edn";
export const DID_YOU_KNOW = "Vedela si, \u017ee...";
export const GROUP_FIND_SOME_IN_A_LIST_OF_GROUPS = "N\u00e1jdi si nejak\u00fa v Zozname skup\u00edn :-)";
export const HINT_FOR_GROUPS = "Na pr\u00edstup do skupiny mus\u00ed\u0161 by\u0165 jej \u010dlenom. Do %(UNLOCKED_GROUPS)s sa vie\u0161 prida\u0165 sama, \u010dlenstvo v %(LOCKED_GROUPS)s ti musia schv\u00e1li\u0165 moder\u00e1tori skupiny.";
export const LOCKED_GROUPS_LOCATIVE = "s\u00fakromn\u00fdch skupin\u00e1ch";
export const RECENT_COMMENTS = "Najnov\u0161ie koment\u00e1re";
export const RECENT_POSTS = "Najnov\u0161ie pr\u00edspevky";
export const SHORTENED_ORDER_BY = "Zora\u010f";
export const UNLOCKED_GROUPS_GENITIVE = "verejn\u00fdch skup\u00edn";
export const YOU_ARE_NOT_IN_ANY_GROUP_SO_FAR = "Zatia\u013e nie si v \u017eiadnej skupine";
